import type { ReactNode } from "react";

type HeroSectionProps = {
  title: ReactNode;
  subtitle: ReactNode;
  ctaLabel: string;
  onCta: () => void;
  videoSrc?: string;
  videoPoster?: string;
};

export default function HeroSection({
  title,
  subtitle,
  ctaLabel,
  onCta,
  videoSrc,
  videoPoster,
}: HeroSectionProps) {
  return (
    <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 sm:pt-24 pb-16">
      <div className="text-center mb-12">
        <h1 className="text-3xl sm:text-5xl font-bold text-slate-900 leading-tight whitespace-pre-line mb-6">
          {title}
        </h1>
        <p className="text-base sm:text-lg text-slate-600 max-w-2xl mx-auto mb-8">
          {subtitle}
        </p>
        <button
          onClick={onCta}
          className="px-8 py-3 text-base font-semibold text-white bg-gradient-to-r from-violet-500 to-purple-500 hover:from-violet-600 hover:to-purple-600 rounded-xl shadow-lg shadow-violet-200 transition-all hover:shadow-xl hover:shadow-violet-300"
        >
          {ctaLabel}
        </button>
      </div>

      {videoSrc && (
        <div className="rounded-xl overflow-hidden shadow-2xl border border-gray-200">
          <video
            src={videoSrc}
            poster={videoPoster}
            autoPlay
            muted
            loop
            playsInline
            className="w-full"
          />
        </div>
      )}
    </section>
  );
}
